module.exports = __webpack_public_path__ + "img/bill.a84f05a9.png";